import React, { useState } from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { t } from 'i18next'
import { ButtonWhiteTwo } from '../Buttons/ButtonWhiteTwo'
import { ButtonWhite } from '../Buttons/ButtonWhite'
import { CustomDateInput } from '../CustomDateInput/CustomDateInput'
import { differenceInYears, isBefore, isFuture } from 'date-fns'

const CustomSelectDate = ({
    showModal,
    setShowModal,
    dateToInitialState = '',
    dateFromInitialState = '',
    onSubmit,
    validateDates = false
}) => {

    const [dateFrom, setDateFrom] = useState(dateFromInitialState);

    const [dateTo, setDateTo] = useState(dateToInitialState);

    const datesExists = String(dateFrom).trim() && String(dateTo).trim();

    const dateToIsGreaterThanDateFrom = datesExists && isBefore(
        new Date(
            Number(dateTo.split('-')[0]),
            (Number(dateTo.split('-')[1]) - 1),
            Number(dateTo.split('-')[2])
        ),
        new Date(
            Number(dateFrom.split('-')[0]),
            (Number(dateFrom.split('-')[1]) - 1),
            Number(dateFrom.split('-')[2])
        )
    );

    const dateToIsFuture = datesExists && isFuture(dateTo);

    const dateRangeIsMoreThanOneYear = datesExists && differenceInYears(dateTo, dateFrom) >= 1;

    const disabled = validateDates ? !datesExists || dateToIsGreaterThanDateFrom || dateRangeIsMoreThanOneYear || dateToIsFuture : !datesExists;

    const handleSubmit = () => {
        if (disabled) return
        onSubmit(dateFrom, dateTo);
        setShowModal(!showModal);
    };

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={() => setShowModal(!showModal)}
            title={t('DATE_RANGE')}
            centered
        >
            <div className='d-flex flex-column gap-5'>
                <div className='d-flex flex-column gap-3'>
                    <div>
                        <label
                            className='form-label'
                            htmlFor="date_from"
                        >
                            {t('DATE_SINCE')}
                        </label>
                        <CustomDateInput
                            name="date_from"
                            value={dateFrom}
                            onChange={setDateFrom}
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="date_to"
                        >
                            {t('DATE_UNTIL')}
                        </label>
                        <CustomDateInput
                            name="date_to"
                            value={dateTo}
                            onChange={setDateTo}
                        />
                    </div>
                </div>
                <div className='d-flex text-center'>
                    <ButtonWhite onClick={() => setShowModal(!showModal)}>
                        {t('CANCEL')}
                    </ButtonWhite>
                    <ButtonWhiteTwo
                        onClick={handleSubmit}
                        disabled={disabled}
                    >
                        {t('SCH_FILT')}
                    </ButtonWhiteTwo>
                </div>
            </div>
        </CustomModal>
    )
}

export default CustomSelectDate